import { Pipe, PipeTransform, Inject } from '@angular/core';
// Simple translate pipe to pass through calls to angular $translate
@Pipe({name: 'translate'})
export class TranslatePipe implements PipeTransform {

  constructor(@Inject('$translate') private $translate) {
  }
  transform(value: string, args: string[]): any {
    return this.$translate.instant(value, args);
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/pipes/translate.pipe.ts